import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import getLabel from '../../utilities/label.js'

export default class SessionRow extends Component {

  toggleStatus() {
    var data = {
      id: this.props.session.id
    }
    // disable toggle status for below
    if (this.props.disabled == true || this.props.session.registration_status === 'session_full' || this.props.session.registration_status === 'not_authorized') {
      return
    } else {
      this.props.postResource({ key: 'session_registration', data: data, callback: (response) => {
        if(response.data.event_session_registration.registration_status === 'double_booked') {
          this.props.flashMessage({
            message: getLabel('schedule_conflict'),
            type: 'error'
          })
          return false
        } else if(response.data.event_session_registration.registration_status === 'session_full'){
          this.props.flashMessage({
            message: 'This session is full.',
            type: 'error'
          })
          return false
        }
      }})
    }
  }

  buttonTextTop(session) {
    if(session.registration_status === 'double_booked' && !session.registration_required) {
      return
    } else if(session.registration_status === 'un_register') {
      return getLabel('reg_label_on')
    } else if(session.registration_status === 'not_authorized') {
      return getLabel('reg_label_invite')
    } else if(session.registration_status === 'session_full') {
      return getLabel('reg_label_session_is')
    } else if (session.registration_required) {
      return getLabel('reg_label_rsvp')
    }
  }

  buttonIcon(session) {
    if(session.registration_status === 'un_register') {
      return <i className="fa fa-check-circle" aria-hidden="true"></i>
    } else if(session.registration_status === 'not_authorized') {
      return <br/>
    } else if(session.registration_status === 'session_full') {
      return <i className="fa fa-plus-circle disabled" aria-hidden="true"></i>
    } else {
      return <i className="fa fa-plus-circle" aria-hidden="true"></i>
    }
  }

  buttonTextBottom(session) {
    if(session.registration_status === 'double_booked' && !session.registration_required) {
      return
    } else if(session.registration_status === 'un_register') {
      return getLabel('reg_label_schedule')
    } else if(session.registration_status === 'not_authorized') {
      return getLabel('reg_label_required')
    } else if(session.registration_status === 'session_full') {
      return getLabel('reg_label_full')
    } else if(session.registration_required) {
      return getLabel('reg_label_required')
    }
  }

  tealText(session) {
    if(session.registration_required && session.registration_status !== 'not_authorized') {
      return 'teal'
    } else {
      return ''
    }
  }

  buttonDetails(session) {
    if(session.registration_status === 'un_register') {
      return <i className="fa fa-check-circle" aria-hidden="true"></i>
    } else {
      return <i className="fa fa-plus-circle" aria-hidden="true"></i>
    }
  }

  sessionNoteIcon() {
    if (this.props.session.note_on_session) {
      return <li><i className="fa fa-sticky-note-o" aria-hidden="true"></i></li>
    }
  }

  getLink(session){
    return(
      <Link className='session-link' key={session.id} to={'/session/' + session.id} >
        <p className='session-name'>{session.name} </p>
        <p className='session-room'>{session.room_name} </p>
      </Link>
    )
  }

  render() {
    const session = this.props.session
    const tealText = this.tealText(session)
    const trackColor = session.track_color ? session.track_color : '#f2f2f2'
    return (
      <div key={session.id} >
        <div className='container'>
          <div className='row session'>
            <button
              className='session-reg'
              onClick={ this.toggleStatus.bind(this, this.props) }
            >
              <p className={'buttonTopText ' + tealText}>{this.buttonTextTop(session)}</p>
              {this.buttonIcon(session)}
              <p className={'buttonBottomText ' + tealText}>{this.buttonTextBottom(session)}</p>
            </button>
            <div className='track-color' style={{ backgroundColor: trackColor }}></div>
            {this.getLink(session)}
            <div className="session-icons">
              <ul>
                { this.sessionNoteIcon() }
              </ul>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
